var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelltrakLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 609.092 154.164",
    style: {
      enableBackground: "new 0 0 609.092 154.164"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M254.127,122.88c-3.099,1.493-10.445,3.33-19.742,3.33c-26.743,0-40.516-16.758-40.516-38.909 c0-26.398,18.824-40.974,42.237-40.974c9.067,0,15.954,1.835,19.053,3.442l-3.673,13.774c-3.443-1.492-8.379-2.87-14.691-2.87 c-13.773,0-24.562,8.379-24.562,25.71c0,15.493,9.182,25.251,24.677,25.251c5.395,0,11.134-1.036,14.692-2.525L254.127,122.88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M274.552,102.337c0.573,7.344,7.689,10.789,15.839,10.789c5.968,0,10.789-0.805,15.495-2.413 l2.296,11.825c-5.739,2.409-12.74,3.557-20.315,3.557c-19.053,0-29.956-11.019-29.956-28.695 c0-14.232,8.953-29.954,28.35-29.954c18.134,0,25.021,14.116,25.021,28.005c0,2.985-0.345,5.624-0.574,7.002L274.552,102.337z  M295.096,90.4c0-4.132-1.836-11.364-9.755-11.364c-7.461,0-10.445,6.771-10.904,11.364H295.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M319.886,43.458h17.446v81.49h-17.446V43.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M349.494,43.458h17.446v81.49h-17.446V43.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA2D8"
    },
    d: "M394.713,62.281h-20.89V47.59h59.455v14.691h-21.12v62.667h-17.446V62.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA2D8"
    },
    d: "M434.078,87.301c0-8.264-0.116-13.659-0.459-18.478h14.92l0.69,10.444h0.459 c2.868-8.264,9.64-11.707,15.15-11.707c1.607,0,2.41,0.115,3.673,0.342v16.413c-1.492-0.23-2.87-0.457-4.821-0.457 c-6.426,0-10.789,3.327-11.936,8.836c-0.231,1.148-0.346,2.41-0.346,3.902v28.35h-17.446L434.078,87.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA2D8"
    },
    d: "M521.192,111.403c0,5.28,0.228,10.444,0.919,13.544h-15.725l-1.033-5.624h-0.343 c-3.674,4.478-9.412,6.887-16.069,6.887c-11.365,0-18.137-8.264-18.137-17.216c0-14.577,13.086-21.463,32.941-21.463v-0.69 c0-2.982-1.606-7.228-10.215-7.228c-5.739,0-11.822,1.95-15.493,4.131l-3.215-11.134c3.902-2.179,11.593-5.049,21.808-5.049 c18.709,0,24.562,11.016,24.562,24.217V111.403z M504.319,98.435c-9.182,0-16.299,2.179-16.299,8.836 c0,4.478,2.985,6.657,6.887,6.657c4.247,0,7.92-2.87,9.068-6.427c0.229-0.917,0.344-1.952,0.344-2.985V98.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA2D8"
    },
    d: "M550.685,92.58h0.23c1.262-2.409,2.64-4.704,4.017-6.772l11.363-16.985h21.005l-20.085,22.725 l22.956,33.399h-21.463l-13.659-23.071l-4.363,5.624v17.446h-17.446v-81.49h17.446V92.58z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA2D8"
    },
    d: "M193.139,30.421c-3.958-10.651-31.071-11.114-66.514-2.69l0.04,1.059 c27.234-6.819,47.786-8.037,51.756-2.003c2.882,4.383-3.581,11.689-16.355,20.08c-13.447,8.834-33.891,18.871-57.881,27.976 C78.07,84.755,53.59,91.294,36.022,93.574c-13.904,1.808-23.479,0.95-26.093-3.021c-3.091-4.701,4.233-12.723,18.609-21.846 l-0.012-0.87C8.614,80.553-2.535,92.896,0.491,101.033c5.337,14.361,52.79,10.196,105.988-9.306 C159.677,72.232,198.477,44.782,193.139,30.421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M335.575,153.288c-0.694,0.362-2.234,0.846-4.197,0.846c-4.408,0-7.277-2.989-7.277-7.458 c0-4.5,3.08-7.761,7.852-7.761c1.57,0,2.959,0.393,3.684,0.755l-0.604,2.053c-0.635-0.362-1.631-0.694-3.08-0.694 c-3.353,0-5.164,2.477-5.164,5.526c0,3.382,2.174,5.466,5.073,5.466c1.51,0,2.506-0.393,3.262-0.725L335.575,153.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M352.458,146.404c0,5.405-3.744,7.761-7.277,7.761c-3.956,0-7.006-2.898-7.006-7.519 c0-4.893,3.201-7.761,7.247-7.761C349.619,138.885,352.458,141.935,352.458,146.404z M340.863,146.555 c0,3.201,1.842,5.616,4.439,5.616c2.536,0,4.438-2.386,4.438-5.677c0-2.477-1.238-5.616-4.379-5.616 C342.222,140.878,340.863,143.777,340.863,146.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M356.538,143.173c0-1.511-0.03-2.748-0.12-3.956h2.355l0.15,2.416h0.061 c0.725-1.39,2.416-2.748,4.831-2.748c2.023,0,5.164,1.208,5.164,6.221v8.727h-2.657v-8.425c0-2.355-0.876-4.318-3.382-4.318 c-1.752,0-3.11,1.238-3.563,2.718c-0.121,0.332-0.182,0.785-0.182,1.238v8.787h-2.657V143.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M374.025,143.173c0-1.511-0.03-2.748-0.12-3.956h2.355l0.15,2.416h0.061 c0.725-1.39,2.416-2.748,4.831-2.748c2.023,0,5.164,1.208,5.164,6.221v8.727h-2.657v-8.425c0-2.355-0.876-4.318-3.382-4.318 c-1.752,0-3.11,1.238-3.563,2.718c-0.121,0.332-0.182,0.785-0.182,1.238v8.787h-2.657V143.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M392.991,147.008c0.061,3.593,2.355,5.073,5.013,5.073c1.903,0,3.051-0.333,4.047-0.756 l0.453,1.903c-0.937,0.422-2.537,0.905-4.862,0.905c-4.499,0-7.187-2.959-7.187-7.368c0-4.408,2.597-7.881,6.854-7.881 c4.771,0,6.04,4.197,6.04,6.885c0,0.543-0.061,0.966-0.091,1.238H392.991z M400.782,145.106 c0.03-1.691-0.694-4.318-3.684-4.318c-2.688,0-3.865,2.476-4.077,4.318H400.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M417.786,153.288c-0.694,0.362-2.234,0.846-4.197,0.846c-4.408,0-7.277-2.989-7.277-7.458 c0-4.5,3.08-7.761,7.852-7.761c1.57,0,2.959,0.393,3.684,0.755l-0.604,2.053c-0.635-0.362-1.631-0.694-3.08-0.694 c-3.353,0-5.164,2.477-5.164,5.526c0,3.382,2.174,5.466,5.073,5.466c1.51,0,2.506-0.393,3.262-0.725L417.786,153.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M425.217,135.02v4.197h3.805v2.023h-3.805v7.881c0,1.812,0.514,2.839,1.993,2.839 c0.694,0,1.208-0.091,1.54-0.182l0.121,1.993c-0.514,0.212-1.329,0.362-2.355,0.362c-1.238,0-2.235-0.393-2.869-1.117 c-0.755-0.785-1.026-2.083-1.026-3.805v-7.972h-2.265v-2.023h2.265v-3.503L425.217,135.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M434.036,147.008c0.061,3.593,2.355,5.073,5.013,5.073c1.903,0,3.051-0.333,4.047-0.756 l0.453,1.903c-0.937,0.422-2.537,0.905-4.862,0.905c-4.499,0-7.187-2.959-7.187-7.368c0-4.408,2.597-7.881,6.854-7.881 c4.771,0,6.04,4.197,6.04,6.885c0,0.543-0.061,0.966-0.091,1.238H434.036z M441.827,145.106 c0.03-1.691-0.694-4.318-3.684-4.318c-2.688,0-3.865,2.476-4.077,4.318H441.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M461.035,132.392v17.666c0,1.298,0.03,2.778,0.12,3.774h-2.386l-0.12-2.536h-0.061 c-0.815,1.63-2.597,2.868-4.982,2.868c-3.533,0-6.251-2.989-6.251-7.429c-0.03-4.861,2.989-7.851,6.553-7.851 c2.234,0,3.744,1.057,4.409,2.234h0.061v-8.728H461.035z M458.378,145.165c0-0.332-0.03-0.785-0.121-1.117 c-0.393-1.69-1.842-3.08-3.835-3.08c-2.748,0-4.379,2.416-4.379,5.647c0,2.959,1.449,5.405,4.318,5.405 c1.781,0,3.412-1.178,3.896-3.171c0.091-0.362,0.121-0.725,0.121-1.147V145.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M474.357,139.217l1.933,7.429c0.422,1.63,0.814,3.14,1.087,4.65h0.091 c0.332-1.48,0.814-3.051,1.298-4.62l2.386-7.459h2.234l2.265,7.308c0.544,1.751,0.967,3.291,1.299,4.771h0.091 c0.241-1.48,0.634-3.021,1.117-4.741l2.083-7.338h2.628l-4.711,14.615h-2.416l-2.234-6.976 c-0.514-1.631-0.937-3.08-1.299-4.802h-0.061c-0.362,1.752-0.814,3.262-1.328,4.832l-2.355,6.945h-2.416l-4.408-14.615 H474.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M499.213,135.11c0.03,0.906-0.635,1.631-1.691,1.631c-0.937,0-1.601-0.725-1.601-1.631 c0-0.936,0.694-1.66,1.661-1.66C498.578,133.45,499.213,134.174,499.213,135.11z M496.253,153.832v-14.615h2.657v14.615 H496.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M507.246,135.02v4.197h3.805v2.023h-3.805v7.881c0,1.812,0.514,2.839,1.993,2.839 c0.694,0,1.208-0.091,1.54-0.182l0.121,1.993c-0.514,0.212-1.329,0.362-2.355,0.362c-1.238,0-2.235-0.393-2.869-1.117 c-0.755-0.785-1.026-2.083-1.026-3.805v-7.972h-2.265v-2.023h2.265v-3.503L507.246,135.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M514.767,132.392h2.657v9.12h0.061c0.423-0.755,1.087-1.419,1.902-1.872 c0.785-0.453,1.722-0.755,2.718-0.755c1.963,0,5.104,1.208,5.104,6.25v8.697h-2.657v-8.395c0-2.355-0.876-4.349-3.382-4.349 c-1.722,0-3.08,1.208-3.563,2.657c-0.151,0.362-0.182,0.755-0.182,1.269v8.817h-2.657V132.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M549.799,153.288c-0.694,0.362-2.234,0.846-4.197,0.846c-4.408,0-7.277-2.989-7.277-7.458 c0-4.5,3.08-7.761,7.852-7.761c1.57,0,2.959,0.393,3.684,0.755l-0.604,2.053c-0.635-0.362-1.631-0.694-3.08-0.694 c-3.353,0-5.164,2.477-5.164,5.526c0,3.382,2.174,5.466,5.073,5.466c1.51,0,2.506-0.393,3.262-0.725L549.799,153.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M561.73,153.832l-0.211-1.842h-0.091c-0.815,1.147-2.386,2.174-4.469,2.174 c-2.96,0-4.47-2.083-4.47-4.197c0-3.533,3.141-5.466,8.788-5.436v-0.302c0-1.208-0.333-3.382-3.322-3.382 c-1.358,0-2.778,0.422-3.805,1.087l-0.604-1.752c1.207-0.785,2.959-1.298,4.801-1.298c4.47,0,5.557,3.05,5.557,5.979v5.466 c0,1.269,0.061,2.507,0.241,3.503H561.73z M561.337,146.373c-2.898-0.061-6.19,0.453-6.19,3.292 c0,1.721,1.147,2.536,2.507,2.536c1.902,0,3.11-1.208,3.533-2.445c0.091-0.272,0.15-0.574,0.15-0.846V146.373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M568.919,143.777c0-1.722-0.03-3.201-0.12-4.56h2.325l0.09,2.868h0.121 c0.664-1.963,2.265-3.2,4.047-3.2c0.302,0,0.513,0.03,0.755,0.09v2.507c-0.272-0.061-0.544-0.091-0.906-0.091 c-1.872,0-3.201,1.42-3.563,3.412c-0.061,0.362-0.12,0.785-0.12,1.238v7.791h-2.628V143.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M580.697,147.008c0.061,3.593,2.355,5.073,5.014,5.073c1.902,0,3.05-0.333,4.046-0.756 l0.453,1.903c-0.937,0.422-2.537,0.905-4.862,0.905c-4.499,0-7.187-2.959-7.187-7.368c0-4.408,2.597-7.881,6.854-7.881 c4.771,0,6.04,4.197,6.04,6.885c0,0.543-0.061,0.966-0.091,1.238H580.697z M588.488,145.106 c0.03-1.691-0.694-4.318-3.684-4.318c-2.688,0-3.865,2.476-4.077,4.318H588.488z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#134471"
    },
    d: "M74.415,107.337v18.148c0,6.837,5.542,12.376,12.377,12.376h25.993 c6.837,0,12.377-5.539,12.377-12.376V94.541h30.944c6.835,0,12.378-5.542,12.378-12.379V67.698 c-15.778,10.18-36.679,20.379-60.186,28.994C96.722,100.933,85.302,104.505,74.415,107.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC2227"
    },
    d: "M102.31,69.901c22.19-8.422,41.74-17.785,55.351-26.487c-0.496-0.062-1.002-0.096-1.515-0.096 h-30.944V12.376C125.202,5.539,119.662,0,112.825,0H86.833c-6.835,0-12.378,5.539-12.378,12.376v30.943H43.512 c-6.837,0-12.379,5.542-12.379,12.379v25.991c0,2.556,0.786,4.919,2.112,6.892c0.692-0.08,1.376-0.154,2.095-0.248 C53.12,86.027,77.528,79.308,102.31,69.901z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003056"
    },
    d: "M609.092,133.299c0,2.808-2.204,5.013-5.072,5.013c-2.839,0-5.104-2.205-5.104-5.013 c0-2.748,2.265-4.952,5.104-4.952C606.888,128.347,609.092,130.551,609.092,133.299z M600.185,133.299 c0,2.204,1.63,3.955,3.865,3.955c2.174,0,3.774-1.751,3.774-3.925c0-2.205-1.601-3.986-3.805-3.986 C601.815,129.343,600.185,131.124,600.185,133.299z M603.235,135.896h-1.147v-4.952c0.452-0.091,1.087-0.151,1.902-0.151 c0.936,0,1.358,0.151,1.721,0.362c0.272,0.212,0.483,0.604,0.483,1.087c0,0.544-0.423,0.967-1.026,1.147v0.061 c0.482,0.182,0.755,0.544,0.905,1.208c0.151,0.755,0.242,1.057,0.362,1.238h-1.237c-0.151-0.182-0.242-0.634-0.393-1.208 c-0.091-0.543-0.393-0.785-1.027-0.785h-0.543V135.896z M603.265,133.087h0.543c0.634,0,1.147-0.211,1.147-0.725 c0-0.453-0.332-0.755-1.057-0.755c-0.302,0-0.514,0.03-0.634,0.061V133.087z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelltrakLogo);
export default __webpack_public_path__ + "static/media/celltrakLogo.71aae95534f6ccf5564707c6970c8c2e.svg";
export { ForwardRef as ReactComponent };